import { Component } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';
import { ApiUrlHelper } from 'src/app/common/apiUrlHelper';
import { CommonConstant } from 'src/app/constants/common-constant';
import { CommonService } from 'src/app/services/common/common.service'; 
import { CompanyConstant } from 'src/app/constants/label-constants';
@Component({
  selector: 'app-company-view',
  templateUrl: './company-view.component.html',
  styleUrls: ['./company-view.component.scss']
})
export class CompanyViewComponent {
  CompanyForm: FormGroup = this.formBuilder.group({});
  CompanyList:any=[];
  imageURL:any;
  companyId:number =0;
  commonConstant:any=[];
  companyConstant:any=[];
  flag:boolean = false;
  constructor(
    private CommonService: CommonService,
    private formBuilder: FormBuilder,
    private apiUrl: ApiUrlHelper,
    public modalService: NgbActiveModal,
    private spinner:NgxSpinnerService
  ) { }

  ngOnInit(): void {
    this.spinner.show();
    this.commonConstant = CommonConstant;
    this.companyConstant = CompanyConstant;
   this.getCompanyDetail(this.companyId);
  }
  
  getCompanyDetail(companyId: number) {
    const apiUrl = this.apiUrl.apiUrl.company.GetCompanyById.replace("{id}", companyId.toString());
    this.CommonService.doGet(apiUrl).pipe().subscribe({
      next: (data) => {       
        this.CompanyList = data.data;
        if (data.data) {
          this.imageURL = data.data.companyLogo ? data.data.companyLogo : '';
        }
        this.spinner.hide(); 
        this.flag = true;      
      },
      error: (err) => {
        console.log('GetCompanyById-Error', err);
      }
    });
  }
}
